/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var b = require("@lexical/link"),
    c = require("@lexical/react/LexicalComposerContext"),
    k = require("@lexical/utils"),
    l = require("lexical"),
    m = require("react");

exports.LinkPlugin = function (_ref) {
  var d = _ref.validateUrl;

  var _c$useLexicalComposer = c.useLexicalComposerContext(),
      _c$useLexicalComposer2 = _slicedToArray(_c$useLexicalComposer, 1),
      e = _c$useLexicalComposer2[0];

  m.useEffect(function () {
    if (!e.hasNodes([b.LinkNode])) throw Error("LinkPlugin: LinkNode not registered on editor");
    return k.mergeRegister(e.registerCommand(b.TOGGLE_LINK_COMMAND, function (a) {
      if (null === a) return b.toggleLink(a), !0;
      if ("string" === typeof a) return void 0 === d || d(a) ? (b.toggleLink(a), !0) : !1;
      var f = a.url,
          g = a.target,
          h = a.rel,
          n = a.title;
      b.toggleLink(f, {
        rel: h,
        target: g,
        title: n
      });
      return !0;
    }, l.COMMAND_PRIORITY_LOW), void 0 !== d ? e.registerCommand(l.PASTE_COMMAND, function (a) {
      var f = l.$getSelection();
      if (!l.$isRangeSelection(f) || f.isCollapsed() || !(a instanceof ClipboardEvent) || null == a.clipboardData) return !1;
      var g = a.clipboardData.getData("text");
      return d(g) ? f.getNodes().some(function (h) {
        return l.$isElementNode(h);
      }) ? !1 : (e.dispatchCommand(b.TOGGLE_LINK_COMMAND, g), a.preventDefault(), !0) : !1;
    }, l.COMMAND_PRIORITY_LOW) : function () {});
  }, [e, d]);
  return null;
};